import React, { LazyExoticComponent } from 'react'
import { Loader, ErrorBoundary } from '@hotmart/hub-components'
import { useAuthStore } from '@hotmart/hub-store'
import { AxiosInterceptor } from '@hotmart/hub-api-client'

type PropsPrivateRoute = {
  sentryTag: { name: string; release: string }
  element?: LazyExoticComponent<React.ComponentType<any>>
  isModal?: boolean
}

function PrivateRoute({ sentryTag, element, isModal }: PropsPrivateRoute) {
  const [UserAuthValue] = useAuthStore()
  const Component = element

  const renderContent = () => {
    return !UserAuthValue?.id_token || UserAuthValue?.renewing ? (
      <Loader />
    ) : (
      <AxiosInterceptor>
        <Component />
      </AxiosInterceptor>
    )
  }

  return (
    <ErrorBoundary sentryTag={sentryTag} isModal={isModal} userId={UserAuthValue?.profile?.id}>
      {renderContent()}
    </ErrorBoundary>
  )
}
export default PrivateRoute
